import { getCheckoutOptions } from './checkouts';

const createEmptyPlayerAdvancedStats = () => ({
  count100Plus: 0,
  count140Plus: 0,
  checkoutOpportunities: 0,
  checkoutSuccess: 0,
  checkoutPct: 0,
  highFinish: 0,
});

export const createEmptyMatchAdvancedStats = () => ({
  jugador1: createEmptyPlayerAdvancedStats(),
  jugador2: createEmptyPlayerAdvancedStats(),
});

export const normalizePlayerAdvancedStats = (stats) => {
  const checkoutOpportunities = Number(stats?.checkoutOpportunities) || 0;
  const checkoutSuccess = Number(stats?.checkoutSuccess) || 0;

  return {
    count100Plus: Number(stats?.count100Plus) || 0,
    count140Plus: Number(stats?.count140Plus) || 0,
    checkoutOpportunities,
    checkoutSuccess,
    checkoutPct: checkoutOpportunities > 0
      ? Math.round((checkoutSuccess / checkoutOpportunities) * 1000) / 10
      : 0,
    highFinish: Number(stats?.highFinish) || 0,
  };
};

export const normalizeMatchAdvancedStats = (stats) => ({
  jugador1: normalizePlayerAdvancedStats(stats?.jugador1),
  jugador2: normalizePlayerAdvancedStats(stats?.jugador2),
});

export const hasCheckoutOpportunity = (score) => getCheckoutOptions(score).length > 0;

const getPlayerKey = (playerIndex) => (playerIndex === 0 ? 'jugador1' : 'jugador2');

export const registerAdvancedTurn = (
  currentStats,
  playerIndex,
  startingScore,
  turnScore,
  didCheckout,
) => {
  const nextStats = normalizeMatchAdvancedStats(currentStats);
  const playerStats = nextStats[getPlayerKey(playerIndex)];

  if (hasCheckoutOpportunity(startingScore)) {
    playerStats.checkoutOpportunities += 1;
  }

  if (turnScore >= 100 && turnScore < 140) {
    playerStats.count100Plus += 1;
  }

  if (turnScore >= 140 && turnScore < 180) {
    playerStats.count140Plus += 1;
  }

  if (didCheckout) {
    playerStats.checkoutSuccess += 1;
    playerStats.highFinish = Math.max(playerStats.highFinish, turnScore);
  }

  playerStats.checkoutPct = playerStats.checkoutOpportunities > 0
    ? Math.round((playerStats.checkoutSuccess / playerStats.checkoutOpportunities) * 1000) / 10
    : 0;

  return nextStats;
};